module.exports = __webpack_public_path__ + "static/media/branded-order-card-success.bc18325f.svg";